export const ADD_GROUP = 'ADD_GROUP';
export const REMOVE_GROUP = 'REMOVE_GROUP';
export const ADD_COUNTER_GROUP = 'ADD_COUNTER_GROUP';
